import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const loggedUser = this.authService.user;
    const userTypes = next.data.userTypes || [];

    if (!loggedUser['xsrfToken']) {
      this.router.navigate(['/login'], {replaceUrl: true});
    } else if (userTypes.length > 0 && !userTypes.includes(loggedUser['user']['userType'])) {
      this.router.navigate(['/no-access'], {replaceUrl: true});
    } else {
      return true
    }
  }
}
